


































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { BulletinState, BulletinModule } from '@/app/store/modules/bulletin'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'
import { BulletinData } from '../../../../../domain/entities/Bulletin'
@Component({
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  // Property Global
  private selected = []
  public get page() {
    return BulletinModule.Pages
  }
  public get limit() {
    return BulletinModule.Limit
  }
  public get isLoading() {
    return BulletinModule.isLoading
  }
  public created() {
    BulletinModule.paginationParam.search = ''
    this.getImage()
    this.getData()
  }
  public getData() {
    BulletinModule.getBulletinData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public get imageLoading() {
    return GalleryImageModule.isLoading
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    BulletinModule.paginationParam.search = item
    this.getData()
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Table
  public get bulletinData(): any {
    return BulletinModule.bulletinData
  }

  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'fileCode', sortable: false },
    { key: 'title', sortable: true },
    { key: 'isActive', sortable: false },
    { key: 'Owner', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'expiredDate', sortable: false },
    { key: 'actions', sortable: false },
  ]
  private onRowSelected(items) {
    this.selected = items
  }

  // Property Pagination
  private onPageNumChanged(limit: any) {
    BulletinModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    BulletinModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    BulletinModule.paginationParam.paging.page =
      BulletinModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    BulletinModule.paginationParam.paging.page =
      BulletinModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    BulletinModule.paginationParam.paging.page =
      (this.bulletinData.pagination &&
        this.bulletinData.pagination.pageCount) ||
      0
    this.getData()
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
